import React, { useEffect, useState } from "react";
import { Autocomplete } from "@mui/material";
import axios from "axios";
import { useOktaAuth } from "@okta/okta-react";
import {useFuelAutocompleteProps} from '@deere/fuel-react/useFuelAutocompleteProps';
import TextField from '@mui/material/TextField';
import Popper from '@mui/material/Popper';
import { styled } from '@mui/material/styles';

const StyledPopperUnit = styled(Popper)(({ theme }) => ({
    '#unit-autocomplete-popper .MuiAutocomplete-paper': {
        maxHeight: 200,
        overflowY: 'auto',
    },
}));



export default function SearchUnit(props) {
  const autocompleteProps = useFuelAutocompleteProps();
  const { oktaAuth } = useOktaAuth();
  const [unitList, setUnitList] = useState([]);

  const unitChangeHandler = (event, newValue, reason) => {
    if (reason === "selectOption") {
      props.setUnitCode(newValue.value);
    } else if (reason === "clear") {
      props.setUnitCode("");
    }
  };
  useEffect(() => {
    const fetchUnitData = async () => {
      const response = await axios.get(
        process.env.REACT_APP_EDI_SETUP_DETAILS_BASE_URL +
          "/api/tpload/unit/list?queryString",
        {
          headers: {
            Authorization: "Bearer " + oktaAuth.getAccessToken(),
          },
        }
      );
      return response;
    };
    fetchUnitData()
      .then((response) => {
        setUnitList(response?.data);
      })
      .catch((error) => {
        console.log(error);
        setUnitList([]);
      });
  }, []);

  return (
    <>
      <Autocomplete
        sx={{ width: 300 }}
        {...autocompleteProps}
        slots={{ popper: StyledPopperUnit }}
        slotProps={{
            popper: {
                popperId: 'unit-autocomplete-popper',
                modifiers: [
                    {
                        name: 'preventOverflow',
                        options: {
                            altAxis: true,
                        },
                    },
                ],
            },
        }}
        onChange={unitChangeHandler}
        inputValue={props.inputUnit}
        onInputChange={(event, newValue, reason) => {
          if (
            (event === null && reason === "reset") ||
            (event.type === "blur" && reason === "reset")
          ) {
            props.setInputUnit("");
          } else {
            props.setInputUnit(newValue);
          }
        }}
        isOptionEqualToValue={(option, value) => {
          return option.label === value.label;
        }}
        options={unitList.map((e) => {
          return {
            value: e.unit_key,
            label: e.unit_key + " - " + e.name,
          };
        })}
        renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    placeholder={'Start Typing...'}
                />
            )}
      />
    </>
  );
}
